/**
 * Utilities for detecting browser reopening vs tab switching
 */

import { debugLog } from './debugLogger';

// Session ID key in sessionStorage
const SESSION_ID_KEY = 'idleFleetSessionId';

/**
 * Generates a new session ID for the current browser session
 * This is used to detect when the browser has been closed and reopened
 * @returns The generated session ID
 */
export const generateSessionId = (): string => {
  const sessionId = `session-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
  sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  debugLog(`Generated new session ID: ${sessionId}`);
  return sessionId;
};

/**
 * Checks if the browser session has changed (browser was closed and reopened)
 * @returns True if this appears to be a new session, false otherwise
 */
export const isNewBrowserSession = (): boolean => {
  const previousSessionId = sessionStorage.getItem(SESSION_ID_KEY);
  
  if (!previousSessionId) {
    debugLog('No previous session ID found, this is a new session');
    generateSessionId();
    return true;
  }
  
  debugLog(`Found existing session ID: ${previousSessionId}`);
  return false;
};
